import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { host } from '../script/variables';
import '../style/EditCafe.css'
import { formatDateTime } from '../script/variables';
import AddImages from './AddImages';
import AddThumbnail from './AddThumbnail';
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import MenuEditor from './MenuEditor';
import AddStartDate from './AddStartDate';

const animatedComponents = makeAnimated();

const CATEGORIES = [
  { value: 'Bar',        emoji: '🍸' },
  { value: 'Restaurant', emoji: '🍽️' },
  { value: 'Cafe',       emoji: '☕' },
  { value: 'Dhaba',      emoji: '🫕' },
  { value: 'Bakery',     emoji: '🥐' },
  { value: 'Food Truck', emoji: '🚚' },
  { value: 'Dessert',    emoji: '🍨' },
  { value: 'Juice Bar',  emoji: '🥤' },
  { value: 'Lounge',     emoji: '🛋️' },
  { value: 'Club',       emoji: '🎵' },
];

const EditCafeDetails = ({ cafeid }) => {
  const [cafe, setCafe] = useState()
  const [images, setImages] = useState(null);
  const [thumbnailImg, setThumbnailImg] = useState(null)
  const [cousine, setCousine] = useState(null);
  const [vibe, setVibe] = useState(null);
  const [ambience, setAmbience] = useState(null);
  const [occasion, setOccasion] = useState(null);
  const [startDate, setStartDate] = useState(null);


  // Remove the existing const [address, setAddress] = useState({...}) and replace:
const [address, setAddress] = useState({
  street: '', city: '', state: '', pin: '', country: 'India', landmark: '',
});



const [addrError, setAddrError] = useState('');

const [geocoding, setGeocoding] = useState(false);
const [geocodeMsg, setGeocodeMsg] = useState('');

const handleAutofillAddress = async () => {
  const lat = cafe.location?.coordinates[1];
  const lng = cafe.location?.coordinates[0];
  if (!lat || !lng) {
    setGeocodeMsg('Save coordinates first, then autofill.');
    return;
  }
  setGeocoding(true);
  setGeocodeMsg('');
  const result = await reverseGeocode(lat, lng);
  setGeocoding(false);
  if (!result) {
    setGeocodeMsg('Could not fetch address. Check coordinates and try again.');
    return;
  }
  setAddress(prev => ({
    ...prev,
    city   : result.city    || prev.city,
    state  : result.state   || prev.state,
    pin    : result.pin     || prev.pin,
    country: result.country || prev.country,
  }));
  setGeocodeMsg('City, state, PIN and country filled from coordinates.');
};

const validateAddress = () => {
  const required = ['street','city','state','pin','country'];
  const missing  = required.filter(k => !address[k]?.trim());
  if (missing.length) return `Please fill in: ${missing.join(', ')}.`;
  if (!/^\d{6}$/.test(address.pin.trim())) return 'PIN code must be exactly 6 digits.';
  return null;
};

const handleAddressUpdate = () => {
  const err = validateAddress();
  if (err) { setAddrError(err); return; }
  setAddrError('');
  const payload = {
    ...address,
    // strip landmark key entirely if empty
    ...(address.landmark.trim() ? {} : { landmark: undefined }),
  };
  handleUpdate('address', payload);
};

  const cousineList = [
   { emoji:'🍛', label:'Indian', value:'indian' },
  { emoji:'🥢', label:'Chinese', value:'chinese' },
  { emoji:'🍕', label:'Italian', value:'italian' },
  { emoji:'🌮', label:'Mexican', value:'mexican' },
  { emoji:'🍜', label:'Thai', value:'thai' },
  { emoji:'🍣', label:'Japanese', value:'japanese' },
  { emoji:'🍲', label:'Korean', value:'korean' },
  { emoji:'🍜', label:'Vietnamese', value:'vietnamese' },
  { emoji:'🍚', label:'Indonesian', value:'indonesian' },
  { emoji:'🍛', label:'Malaysian', value:'malaysian' },
  { emoji:'🍤', label:'Singaporean', value:'singaporean' },
  { emoji:'🍔', label:'American', value:'american' },
  { emoji:'🥧', label:'British', value:'british' },
  { emoji:'🥖', label:'French', value:'french' },
  { emoji:'🥘', label:'Spanish', value:'spanish' },
  { emoji:'🥙', label:'Greek', value:'greek' },
  { emoji:'🍖', label:'Turkish', value:'turkish' },
  { emoji:'🥙', label:'Lebanese', value:'lebanese' },
  { emoji:'🫒', label:'Mediterranean', value:'mediterranean' },
  { emoji:'🍢', label:'Middle Eastern', value:'middle_eastern' },
  { emoji:'🥘', label:'Arabic', value:'arabic' },
  { emoji:'🍢', label:'Persian (Iranian)', value:'persian' },
  { emoji:'🥨', label:'German', value:'german' },
  { emoji:'🥟', label:'Russian', value:'russian' },
  { emoji:'🥟', label:'Polish', value:'polish' },
  { emoji:'🥟', label:'Ukrainian', value:'ukrainian' },
  { emoji:'🥘', label:'Hungarian', value:'hungarian' },
  { emoji:'🍖', label:'Brazilian', value:'brazilian' },
  { emoji:'🥩', label:'Argentinian', value:'argentinian' },
  { emoji:'🍲', label:'Peruvian', value:'peruvian' },
  { emoji:'🥘', label:'Colombian', value:'colombian' },
  { emoji:'🍹', label:'Caribbean', value:'caribbean' },
  { emoji:'🥩', label:'Cuban', value:'cuban' },
  { emoji:'🍗', label:'Jamaican', value:'jamaican' },
  { emoji:'🥘', label:'Ethiopian', value:'ethiopian' },
  { emoji:'🍲', label:'Moroccan', value:'moroccan' },
  { emoji:'🥘', label:'Tunisian', value:'tunisian' },
  { emoji:'🍖', label:'South African', value:'south_african' },
  { emoji:'🍲', label:'Nigerian', value:'nigerian' },
  { emoji:'🍛', label:'Kenyan', value:'kenyan' },
  { emoji:'🥩', label:'Australian', value:'australian' },
  { emoji:'🥧', label:'New Zealand', value:'new_zealand' },
  { emoji:'🍽️', label:'Fusion', value:'fusion' },
  { emoji:'🍽️', label:'Continental', value:'continental' },
  { emoji:'🍔', label:'Fast Food', value:'fast_food' },
  { emoji:'🥙', label:'Street Food', value:'street_food' },
  { emoji:'🔥', label:'BBQ', value:'bbq' },
  { emoji:'🍖', label:'Grill', value:'grill' },
  { emoji:'🐟', label:'Seafood', value:'seafood' },
  { emoji:'🥗', label:'Vegetarian', value:'vegetarian' },
  { emoji:'🌱', label:'Vegan', value:'vegan' },
  { emoji:'🍰', label:'Desserts', value:'desserts' },
  { emoji:'🥐', label:'Bakery', value:'bakery' },
  { emoji:'☕', label:'Cafe', value:'cafe' },
  { emoji:'🥤', label:'Beverages', value:'beverages' }
  ];

  const AMBIENCE_FILTERS = [
  { emoji: '🏙️',  label: 'Rooftop',         value: 'rooftop'           },
  { emoji: '🌿',  label: 'Open Garden',      value: 'open-garden'       },
  { emoji: '🌤️',  label: 'Open Roof Ground', value: 'open-roof-ground'  },
  { emoji: '🕯️',  label: 'Candlelit',        value: 'candlelit'         },
  { emoji: '🎵',  label: 'Live Music',        value: 'live-music'        },
  { emoji: '🌊',  label: 'Waterfront',        value: 'waterfront'        },
  { emoji: '🏡',  label: 'Rustic Cottage',   value: 'rustic-cottage'    },
  { emoji: '🌃',  label: 'Night View',        value: 'night-view'        },
  { emoji: '🪵',  label: 'Bonfire Seating',  value: 'bonfire'           },
  { emoji: '🌁',  label: 'Terrace',           value: 'terrace'           },
  { emoji: '🏖️',  label: 'Beach Shack',       value: 'beach'             },
  { emoji: '📚',  label: 'Book Café',         value: 'book-cafe'         },
  { emoji: '🎨',  label: 'Art Café',          value: 'art-cafe'          },
  { emoji: '🐾',  label: 'Pet Friendly',      value: 'pet-friendly'      },
  { emoji: '💻',  label: 'Work-Friendly',     value: 'work-friendly'     },
  { emoji: '🌙',  label: 'Late Night',        value: 'late-night'        },
];

  const VIBE_FILTERS = [
  { emoji: '🎭', label: 'Malayalam Theme',   value: 'malayalam'    },
  { emoji: '🌺', label: 'Kannada Theme',     value: 'kannada'      },
  { emoji: '🪔', label: 'Tamil Theme',       value: 'tamil'        },
  { emoji: '🦚', label: 'Telugu Theme',      value: 'telugu'       },
  { emoji: '🏮', label: 'Chinese Theme',     value: 'chinese-vibe' },
  { emoji: '⛩️', label: 'Japanese Theme',    value: 'japanese-vibe'},
  { emoji: '🕌', label: 'Arabian Nights',    value: 'arabian'      },
  { emoji: '🎪', label: 'Rajasthani Theme',  value: 'rajasthani'   },
  { emoji: '🛕', label: 'Bengali Theme',     value: 'bengali'      },
  { emoji: '🌍', label: 'African Theme',     value: 'african'      },
  { emoji: '🥐', label: 'Parisian Bistro',   value: 'parisian'     },
  { emoji: '🍝', label: 'Italian Trattoria', value: 'italian-vibe' },
  { emoji: '🌯', label: 'Mediterranean',     value: 'mediterranean'},
  { emoji: '🎸', label: 'Punjabi Dhaba',     value: 'punjabi-dhaba'},
  { emoji: '🏔️', label: 'Himalayan Theme',   value: 'himalayan'    },
  { emoji: '🎋', label: 'Thai Theme',        value: 'thai-vibe'    },
  { emoji: '🌵', label: 'Mexican Cantina',   value: 'mexican-vibe' },
  { emoji: '☘️', label: 'Irish Pub Vibe',    value: 'irish'        },
];

  const OCCASION_FILTERS = [
  { emoji:'🎂', label:'Birthday Party', value:'birthday' },
  { emoji:'💍', label:'Anniversary', value:'anniversary' },
  { emoji:'🎊', label:'Promotion Party', value:'promotion' },
  { emoji:'🏢', label:'Corporate Party', value:'corporate' },
  { emoji:'🎓', label:'Graduation Party', value:'graduation' },
  { emoji:'👋', label:'Farewell Party', value:'farewell' },
  { emoji:'👨‍👩‍👧‍👦', label:'Family Get-together', value:'family' },
  { emoji:'🥳', label:'Celebration Dinner', value:'celebration' },
  { emoji:'🍾', label:'Achievement Party', value:'achievement' },
  { emoji:'💑', label:'Date Night', value:'date' },
  { emoji:'🤝', label:'Business Meeting', value:'business_meeting' },
  { emoji:'🎤', label:'Event Hosting', value:'event_hosting' },
  { emoji:'🎶', label:'After Party', value:'after_party' },
  { emoji:'🍻', label:'Friends Hangout', value:'friends' },
  { emoji:'🙏', label:'Festive Gathering', value:'festival' }
];

  const msToTime = (ms) => {
    if (!ms && ms !== 0) return '';
    const totalMinutes = Math.floor(ms / 60000);
    const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
    const minutes = String(totalMinutes % 60).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const timeToMs = (timeStr) => {
    if (!timeStr) return 0;
    const [h, m] = timeStr.split(':').map(Number);
    return ((h * 60) + m) * 60000;
  };


  


  const reverseGeocode = async (lat, lng) => {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1`,
      { headers: { 'Accept-Language': 'en', 'User-Agent': 'RestroPilots/1.0' } }
    );
    if (!res.ok) return null;
    const data = await res.json();
    const a = data.address || {};
    return {
      city    : a.city || a.town || a.village || a.county || '',
      state   : a.state || '',
      pin     : a.postcode || '',
      country : a.country || 'India',
    };
  } catch {
    return null;
  }
};

  /* ---------- API ---------- */
  const handleUpdate = async (field, value) => {
    try {
      const token = localStorage.getItem('partnertoken');
      const response = await fetch(`${host}/cafe/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
        body: JSON.stringify({ parameter: field, value, resId: cafe._id })
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      console.log('Updated successfully:', data);
      return data;
    } catch (error) {
      console.error('Error updating:', error);
      throw error;
    }
  };

  const handleCoordinateChange = (index, value) => {
    const newCoordinates = [...cafe.location.coordinates];
    newCoordinates[index] = parseFloat(value);
    setCafe({ ...cafe, location: { ...cafe.location, coordinates: newCoordinates } });
  };

  const handleArrayUpdate = (field, index, newValue) => {
    const newArray = [...cafe[field]];
    newArray[index] = newValue;
    setCafe({ ...cafe, [field]: newArray });
    handleUpdate(field, newArray);
  };

  const handleAddToArray = (field, newValue) => {
    const newArray = [...cafe[field], newValue];
    setCafe({ ...cafe, [field]: newArray });
    handleUpdate(field, newArray);
  };

  const handleThumbnailUpdate = (newUrl) => {
    setCafe({ ...cafe, thumbnail: newUrl });
    handleUpdate('thumbnail', newUrl);
  };

  const fetchCafeDetails = async () => {
    try {
      const response = await fetch(`${host}/outlet/findOutletById?cafeid=${cafeid}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        setCafe(data.data);
        setImages(data.data.images);
        setThumbnailImg(data.data.thumbnail);
      }
    } catch (error) {
      console.log('Error fetching cafe details:', error);
    }
  };

  // ── Category: normalize to array, toggle individual values ──────────────
  const selectedCategories = Array.isArray(cafe?.category)
    ? cafe.category
    : cafe?.category ? [cafe.category] : [];

  const toggleCategory = (value) => {
    const next = selectedCategories.includes(value)
      ? selectedCategories.filter(c => c !== value)
      : [...selectedCategories, value];
    setCafe({ ...cafe, category: next });
  };

  const handleCouisine = (selected) => {
    setCafe({ ...cafe, cousine: selected.map(v => v.value) });
  };

  const handleVibe = (selected) => {
    setCafe({ ...cafe, vibe: selected.map(v => v.value) });
  };

  const handleAmbience = (selected) => {
    setCafe({ ...cafe, ambience: selected.map(v => v.value) });
  };

  const handleOccasion = (selected) => {
    setCafe({ ...cafe, occasion: selected.map(v => v.value) });
  };

  useEffect(() => {
    fetchCafeDetails();
  }, []);
  // Add this effect — runs once when cafe loads from the API:
useEffect(() => {
  if (!cafe) return;
  setAddress({
    street  : cafe.address?.street   || '',
    city    : cafe.address?.city     || '',
    state   : cafe.address?.state    || '',
    pin     : cafe.address?.pin      || '',
    country : cafe.address?.country  || 'India',
    landmark: cafe.address?.landmark || '',
  });
}, [cafe?._id]); // only re-run when a different cafe loads, not on every field edit


  if (!cafe) return <div className="cafe-form-loading">Loading cafe details…</div>;

  return (
    <div className="cafe-form">

      {/* ── Menu Editor ── */}
      <div className="form-group">
        {cafe && <MenuEditor cafe={cafe} setCafe={setCafe} />}
      </div>

      {/* ── Name ── */}
      <div className="form-group">
        <label>Name</label>
        <input
          type="text"
          value={cafe.name}
          onChange={(e) => setCafe({ ...cafe, name: e.target.value })}
        />
        <button onClick={() => handleUpdate('name', cafe.name)}>Update</button>
      </div>

      {/* ── Thumbnail ── */}
      <div className="form-group">
        <label>Thumbnail</label>
        <AddThumbnail
          setThumbnailImg={handleThumbnailUpdate}
          thumbnailImg={thumbnailImg}
        />
      </div>

      {/* ── Images ── */}
      <div className="form-group">
        <label>Images</label>
        <AddImages
          setCafeImg={(newImages) => {
            setImages(newImages);
            handleUpdate('images', newImages);
          }}
          cafeImg={images}
        />
      </div>

      {/* ── Location ── */}
      {/* ── Location ── */}
<div className="form-group">
  <label>Location</label>
  <div className="location-inputs">
    <input
      type="number"
      placeholder="Latitude"
      value={cafe.location.coordinates[1] || ''}
      onChange={(e) => handleCoordinateChange(1, e.target.value)}
    />
    <input
      type="number"
      placeholder="Longitude"
      value={cafe.location.coordinates[0] || ''}
      onChange={(e) => handleCoordinateChange(0, e.target.value)}
    />
  </div>
   <button onClick={() => handleUpdate('location', cafe.location)}>Update</button>
</div>
{/* ── Category (multi-select dropdown) ── */}
<div className="form-group">
  <label>Category</label>
  {selectedCategories.length > 0 && (
    <div className="cuisine-existing">
      {selectedCategories.map((c, i) => (
        <span className="cuisine-tag" key={i}>{c}</span>
      ))}
    </div>
  )}
  <Select
    closeMenuOnSelect={false}
    components={animatedComponents}
    onChange={(selected) =>
      setCafe({ ...cafe, category: selected.map(v => v.value) })
    }
    placeholder="Select categories…"
    isMulti
    options={CATEGORIES.map(({ value, emoji }) => ({
      value,
      label: `${emoji} ${value}`,
    }))}
    classNamePrefix="react-select"
  />
  <button onClick={() => handleUpdate('category', cafe.category)}>Update</button>
</div>

      {/* ── Website ── */}
      <div className="form-group">
        <label>Website</label>
        <input
          type="text"
          value={cafe.website}
          onChange={(e) => setCafe({ ...cafe, website: e.target.value })}
        />
        <button onClick={() => handleUpdate('website', cafe.website)}>Update</button>
      </div>

      {/* ── Title ── */}
      <div className="form-group">
        <label>Title</label>
        <input
          type="text"
          value={cafe.title}
          onChange={(e) => setCafe({ ...cafe, title: e.target.value })}
        />
        <button onClick={() => handleUpdate('title', cafe.title)}>Update</button>
      </div>

      {/* ── Description ── */}
      <div className="form-group">
        <label>Description</label>
        <textarea
          value={cafe.description}
          onChange={(e) => setCafe({ ...cafe, description: e.target.value })}
        />
        <button onClick={() => handleUpdate('description', cafe.description)}>Update</button>
      </div>

      {/* ── Opening Time ── */}
      <div className="form-group">
        <label>Opening Time</label>
        <input
          type="time"
          value={msToTime(cafe.opensAt)}
          onChange={(e) => setCafe({ ...cafe, opensAt: timeToMs(e.target.value) })}
        />
        <button onClick={() => handleUpdate('opensAt', cafe.opensAt)}>Update</button>
      </div>

      {/* ── Closing Time ── */}
      <div className="form-group">
        <label>Closing Time</label>
        <input
          type="time"
          value={msToTime(cafe.CloseAt)}
          onChange={(e) => setCafe({ ...cafe, CloseAt: timeToMs(e.target.value) })}
        />
        <button onClick={() => handleUpdate('CloseAt', cafe.CloseAt)}>Update</button>
      </div>

      {/* ── Menu Type ── */}
      <div className="form-group">
        <label>Menu Type</label>
        <select
          value={cafe.menuType}
          onChange={(e) => setCafe({ ...cafe, menuType: e.target.value })}
        >
          <option value="veg">Veg</option>
          <option value="nonveg">Non-Veg</option>
          <option value="omnivores">Omnivores</option>
        </select>
        <button onClick={() => handleUpdate('menuType', cafe.menuType)}>Update</button>
      </div>

      {/* ── Cuisine ── */}
      <div className="form-group">
        <label>Cuisine</label>
        {cafe.cousine && cafe.cousine.length > 0 && (
          <div className="cuisine-existing">
            {cafe.cousine.map((c, i) => (
              <span className="cuisine-tag" key={i}>{c}</span>
            ))}
          </div>
        )}
        <Select
          closeMenuOnSelect={false}
          components={animatedComponents}
          onChange={handleCouisine}
          placeholder="Select cuisines…"
          isMulti
          options={cousineList}
          classNamePrefix="react-select"
        />
        <button onClick={() => handleUpdate('cousine', cafe.cousine)}>Update</button>
      </div>

      {/* ── Vibes ── */}
      <div className="form-group">
        <label>Vibes</label>
        {cafe.vibe && cafe.vibe.length > 0 && (
          <div className="cuisine-existing">
            {cafe.vibe.map((c, i) => (
              <span className="cuisine-tag" key={i}>{c}</span>
            ))}
          </div>
        )}
        <Select
          closeMenuOnSelect={false}
          components={animatedComponents}
          onChange={handleVibe}
          placeholder="Select vibes…"
          isMulti
          options={VIBE_FILTERS}
          classNamePrefix="react-select"
        />
        <button onClick={() => handleUpdate('vibe', cafe.vibe)}>Update</button>
      </div>

      {/* ── Ambience ── */}
      <div className="form-group">
        <label>Ambience</label>
        {cafe.ambience && cafe.ambience.length > 0 && (
          <div className="cuisine-existing">
            {cafe.ambience.map((c, i) => (
              <span className="cuisine-tag" key={i}>{c}</span>
            ))}
          </div>
        )}
        <Select
          closeMenuOnSelect={false}
          components={animatedComponents}
          onChange={handleAmbience}
          placeholder="Select ambience…"
          isMulti
          options={AMBIENCE_FILTERS}
          classNamePrefix="react-select"
        />
        <button onClick={() => handleUpdate('ambience', cafe.ambience)}>Update</button>
      </div>

      {/* ── Occasion ── */}
      <div className="form-group">
        <label>Occasion</label>
        {cafe.occasion && cafe.occasion.length > 0 && (
          <div className="cuisine-existing">
            {cafe.occasion.map((c, i) => (
              <span className="cuisine-tag" key={i}>{c}</span>
            ))}
          </div>
        )}
        <Select
          closeMenuOnSelect={false}
          components={animatedComponents}
          onChange={handleOccasion}
          placeholder="Select occasion…"
          isMulti
          options={OCCASION_FILTERS}
          classNamePrefix="react-select"
        />
        <button onClick={() => handleUpdate('occasion', cafe.occasion)}>Update</button>
      </div>

        {/* ── Start Date ── */}
      <div className="form-group">
       
        {cafe.startDate  && (
          <div className="cuisine-existing">
            
              <span className="cuisine-tag" key={cafe.startDate}>{cafe.startDate}</span>
            
          </div>
        )}
        <AddStartDate  startDate={startDate} setStartDate={setStartDate}  />
        <button onClick={() => handleUpdate('startDate', startDate)}>Update</button>
      </div>

<div className="form-group">
  <label>Restaurant Address</label>
<div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
   
    <button
      onClick={handleAutofillAddress}
      disabled={geocoding}
      
    >
      {geocoding ? 'Fetching…' : '✦ Autofill address from coordinates'}
    </button>
  </div>
  {geocodeMsg && (
    <p style={{
      fontSize: '12px',
      marginTop: '6px',
      color: geocodeMsg.startsWith('Could') ? '#c0472b' : '#2d7a4f'
    }}>
      {geocodeMsg}
    </p>
  )}
  <div className="form-field">
    <label className="field-label">Street address</label>
    <input
      type="text"
      placeholder="Building no., street name"
      value={address.street}
      onChange={e => setAddress({ ...address, street: e.target.value })}
    />
  </div>

  <div className="form-row">
    <div className="form-field">
      <label className="field-label">City</label>
      <input
        type="text"
        placeholder="City"
        value={address.city}
        onChange={e => setAddress({ ...address, city: e.target.value })}
      />
    </div>
    <div className="form-field">
      <label className="field-label">State</label>
      <input
        type="text"
        placeholder="State"
        value={address.state}
        onChange={e => setAddress({ ...address, state: e.target.value })}
      />
    </div>
  </div>

  <div className="form-row">
    <div className="form-field">
      <label className="field-label">PIN code</label>
      <input
        type="text"
        placeholder="6-digit PIN"
        maxLength={6}
        inputMode="numeric"
        value={address.pin}
        onChange={e => setAddress({ ...address, pin: e.target.value.replace(/\D/g, '') })}
      />
    </div>
    <div className="form-field">
      <label className="field-label">Country</label>
      <input
        type="text"
        placeholder="India"
        value={address.country}
        onChange={e => setAddress({ ...address, country: e.target.value })}
      />
    </div>
  </div>

  <div className="form-field">
    <label className="field-label">
      Landmark <span className="optional-label">optional</span>
    </label>
    <input
      type="text"
      placeholder="e.g. Near metro station, opposite city mall"
      value={address.landmark}
      onChange={e => setAddress({ ...address, landmark: e.target.value })}
    />
  </div>

  {addrError && <p className="form-error">{addrError}</p>}

  <button onClick={handleAddressUpdate}>Update address</button>
</div>




    </div>
  );
};

export default EditCafeDetails;